import { Box, CSS, Text } from '@air/marketing-primitives';

import { Container } from '~/old-marketing/components/globals/Container';
import * as StyledDefaultFooter from '~/old-marketing/components/globals/footers/DefaultFooter.styles';
import { Logo } from '~/old-marketing/components/globals/Logo';
import { Link } from '~/old-marketing/components/primitives/Link';
import { FOOTER_NAVIGATION, FOOTER_SOCIAL_NAVIGATION } from '~/old-marketing/constants/navigation';
import { Routes } from '~/old-marketing/constants/Routes';
import { FOOTER } from '~/old-marketing/constants/testIds';

export const DefaultFooter = ({ css }: { css?: CSS }) => {
  const currentYear = new Date().getFullYear();

  return (
    <StyledDefaultFooter.Root css={css} data-testid={FOOTER}>
      <Container
        css={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          marginBottom: 24,

          '@laptop': {
            flexDirection: 'row',
            marginBottom: 48,
          },
        }}
      >
        <StyledDefaultFooter.Info>
          <Logo css={{ fill: 'jay900', height: 32, marginBottom: 24 }} />

          <Box
            css={{
              display: 'flex',
              flexDirection: 'row',

              '@laptop': {
                flexDirection: 'column',
              },
            }}
          >
            {FOOTER_SOCIAL_NAVIGATION.map((navigationItem, index) => {
              return (
                <Link
                  css={{ marginBottom: 16, color: '$pigeon700' }}
                  href={navigationItem.href}
                  key={index}
                  size="ui-14"
                >
                  <Box
                    as={navigationItem.icon}
                    css={{
                      display: 'block',
                      width: 24,
                      marginLeft: 12,
                      marginRight: 0,

                      '@laptop': {
                        marginLeft: 0,
                        marginRight: 8,
                      },
                    }}
                  />
                  <Box as="span" css={{ display: 'none', '@laptop': { display: 'inline' } }}>
                    {navigationItem.label}
                  </Box>
                </Link>
              );
            })}
          </Box>
        </StyledDefaultFooter.Info>

        <StyledDefaultFooter.NavigationContainer>
          {FOOTER_NAVIGATION.map((column, index) => {
            return (
              <StyledDefaultFooter.Navigation key={index}>
                <Text
                  as="h2"
                  css={{
                    marginBottom: 24,
                    color: '$pigeon800',
                    fontWeight: '$semibold',
                  }}
                  id={column.title}
                  size={{
                    '@initial': 'ui-14',
                    '@laptop': 'ui-20',
                  }}
                >
                  {column.title}
                </Text>
                {column.items.map((item, index) => {
                  return (
                    <Link
                      css={{ marginBottom: 16, color: '$pigeon700' }}
                      href={item.href}
                      key={index}
                      type={item.type}
                      size="ui-14"
                    >
                      {item.label}
                    </Link>
                  );
                })}
              </StyledDefaultFooter.Navigation>
            );
          })}
        </StyledDefaultFooter.NavigationContainer>
      </Container>
      <Container>
        <Text
          css={{ width: 'calc(100% - 93px)', color: '$jay900' }}
          size={{
            '@initial': 'ui-12',
            '@laptop': 'ui-14',
          }}
        >
          Copyright &copy; {currentYear} Air, Inc. All rights reserved.{' '}
          <Link href={Routes.terms} css={{ fontSize: 'inherit' }}>
            Terms
          </Link>
          {' & '}
          <Link href={Routes.privacy} css={{ fontSize: 'inherit' }}>
            Privacy
          </Link>
        </Text>
      </Container>
    </StyledDefaultFooter.Root>
  );
};
